import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxValidator, DxValidationRule } from 'devextreme-vue/validator';
import { computed } from 'vue';
//import { formEditorProps } from '@/shared/form-editor-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'form-textbox',
  props: {
    modelValue: { default: null },
    isEditing: { type: Boolean, default: false },
    label: { default: '' },
    icon: { default: '' },
    mask: { default: '' },
    validationGroup: { default: '' },
    validators: { default: () => [{ type: 'required' }] },
    buttons: { default: () => [] }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxTextBox), {
    label: __props.label,
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    "read-only": !__props.isEditing,
    mask: __props.mask,
    buttons: __props.buttons
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxValidator), {
        "validation-rules": __props.validators,
        "validation-group": __props.validationGroup
      }, null, 8, ["validation-rules", "validation-group"]),
      (__props.icon)
        ? (_openBlock(), _createBlock(_unref(DxTextBoxButton), {
            key: 0,
            options: { icon: __props.icon, elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' },
            name: "icon",
            location: "before"
          }, null, 8, ["options"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label", "modelValue", "read-only", "mask", "buttons"]))
}
}

})